<template>
  <div>
    <v-row class="d-flex align-start" t-data='history-row'>
      <v-col
        t-data="history-value"
        class="no-top-bottom-space information-label sub-body-regular"
        cols="3"
      >
        {{ dateFmt(newValueLog.updated_at) }}
      </v-col>
      <v-col
        t-data="history-value"
        class="no-top-bottom-space information-label sub-body-regular"
        cols="3"
      >
        {{ item.modified_by_user_name }}
      </v-col>
      <v-col
        t-data="history-value"
        class="no-top-bottom-space information-label sub-body-regular text-center"
        cols="2"
      >
        {{ newValueLog.is_status }}
      </v-col>
      <v-col
        t-data="history-value"
        class="no-top-bottom-space information-label sub-body-regular"
        cols="4"
      >
        {{ newValueLog.remark }}
      </v-col>
    </v-row>
  </div>
</template>

<script>


import {convertDate} from '@/helper/helper'

export default {
  name: 'HistoryItem',
  props: {
    item: {type: Object},
  },
  computed: {
    newValueLog() {
      return JSON.parse(this.item.new_value)
    }
  },
  methods: {
    dateFmt: date => convertDate(date),
  }
}
</script>
